import { useTranslation } from "react-i18next";

import { cn } from "@/utils/utils";
import { UserConsentState } from "@/models/site-credentials/consents/UserAppConsents";

type ConsentStatusBadgeProps = {
  state: UserConsentState;
  className?: string;
};

export default function ConsentStatusBadge({ state, className }: ConsentStatusBadgeProps) {
  const { t } = useTranslation();

  const isAllowed = state === "Accepted";

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full border px-6 py-1 text-xs font-medium whitespace-nowrap",
        isAllowed
          ? "bg-[var(--surface-semantic-success-variant)] border-[var(--outline-semantic-success)] text-[var(--on-semantic-success-variant)]"
          : "bg-[var(--surface-semantic-error-variant)] border-[var(--outline-semantic-error)] text-[var(--on-semantic-error-variant)]",
        className
      )}
    >
      {t(isAllowed ? "site_credentials.consents.status.allowed" : "site_credentials.consents.status.refused")}
    </span>
  );
}
